window.location.platform = (platform, siteHostname) => {
  "use strict";

  // Determine where the platform ends in the URL based on the site hostname. Platform matching
  // is dependent on the URL and what comes from hostnameMatchService.
  let platformEndIndex = window.location.hostname.indexOf("." + siteHostname);
  // Get the platform based on the determined index
  let urlPlatform = (platformEndIndex > 0) ? window.location.hostname.substring(0, platformEndIndex) : null;
  let hostnameSplit = window.location.hostname.split('.');

  if (typeof platform === 'undefined') {
    // If we have a platform from the URL, use that
    if (urlPlatform) {
      return urlPlatform;
    } else {
      // Otherwise return the first item from the window hostname
      return hostnameSplit[0];
    }
  } else if (platform == "api") {
    hostnameSplit[0] = platform;
    return `//${hostnameSplit.join('.')}`;
  } else {
    // If a platform is provided, use that. Otherwise default to www
    urlPlatform = platform ? platform : 'www';
    return '//' + urlPlatform + "." + siteHostname;
  }
};

window.location.api = (path) => {
  "use strict";

  if(!!path) path = '/' + path.replace(/^\//, '');
  else path = '';

  return 'https://' + window.location.platform('api') + ":443" + path;
};



// WEBPACK FOOTER //
// ./app.v2/assets/js/window.location.js